import { render } from "./ApplyConfigTemplate.vue?vue&type=template&id=2c6bc12f"
import script from "./ApplyConfigTemplate.vue?vue&type=script&lang=js"
export * from "./ApplyConfigTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__